// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-title-labeled{position:relative;display:inline-block}.ac-title-labeled__label{background-color:#3E3E3E;border-radius:3px;color:#fff;font-size:0.7rem;left:calc(100% + 5px);line-height:1.9;padding:0 5px;position:absolute;top:-5px}\n", ""]);
// Exports
module.exports = exports;
